import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

const Frame = ({
	children,
	big,
	small,
	file,
	hover,
	className,
	onClick,
	...rest
}) => (
	<i
		className={cx(
			"icon",
			{
				"icon--big": big,
				"icon--small": small,
				"icon--file": file,
				"icon--hover": hover,
			},
			className,
		)}
		onClick={onClick}
		{...rest}
	>
		{children}
	</i>
);
Frame.propTypes = {
	hover: PropTypes.bool,
	big: PropTypes.bool,
	small: PropTypes.bool,
	file: PropTypes.bool,
	onClick: PropTypes.func,
};
Frame.defaultProps = {
	hover: false,
	big: false,
	small: false,
	file: false,
	onClick: () => {},
};
const iconModules = import.meta.glob(["./*.js", "!./Icon.js"]);

const Icon = (props) => {
	const { name } = props;
	const capitalized = name.extensions.capitalize();
	const loadIcon = iconModules[`./${capitalized}.js`];
	const Ico = React.lazy(loadIcon);
	return (
		<React.Suspense fallback={<Frame {...props} />}>
			<Frame {...props}>
				<Ico />
			</Frame>
		</React.Suspense>
	);
};
Icon.propTypes = {
	name: PropTypes.string.isRequired,
	big: PropTypes.bool,
	small: PropTypes.bool,
	file: PropTypes.bool,
	onClick: PropTypes.func,
};
Icon.defaultProps = {
	big: false,
	small: false,
	file: false,
	onClick: () => {},
};
export default Icon;
